import React from 'react';
import { Link } from 'react-router-dom';
import { PublicLegalShell } from '../components/layout/PublicLegalShell';

export default function ContactPage() {
  return (
    <PublicLegalShell title="Contact" eyebrow="Support">
      <p>
        We are here to help with account questions, privacy requests, memorial guidance and partner enquiries.
      </p>
      <p>
        Email us at{' '}
        <a href="mailto:support@mylegacybridge.com" className="text-[hsl(38_36%_42%)] underline underline-offset-2">
          support@mylegacybridge.com
        </a>{' '}
        and we will respond as soon as we can.
      </p>
      <ul className="list-disc space-y-2 pl-5">
        <li>General support and FAQ — start with our <Link to="/faq" className="text-[hsl(38_36%_42%)] underline underline-offset-2">FAQ</Link></li>
        <li>Privacy and data deletion — see <Link to="/privacy#data" className="text-[hsl(38_36%_42%)] underline underline-offset-2">privacy requests</Link></li>
        <li>Partner enquiries — visit <Link to="/partners" className="text-[hsl(38_36%_42%)] underline underline-offset-2">Partners</Link></li>
      </ul>
    </PublicLegalShell>
  );
}
